import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";

const ACCENTS = [
  { color: "text-cyan-400", border: "hover:border-cyan-400/40" },
  { color: "text-fuchsia-500", border: "hover:border-fuchsia-500/40" },
  { color: "text-yellow-300", border: "hover:border-yellow-300/40" },
];

export default function Manifesto() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings").then(({ data }) => setSettings(data)).catch(() => {});
  }, []);

  const cards = (settings?.manifesto_cards || []).filter((c) => c.title || c.description);
  if (!settings || !cards.length) return null;

  return (
    <section id="manifesto" data-testid="manifesto-section" className="border-t border-white/10 bg-[#0F1015]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-fuchsia-400" data-testid="manifesto-eyebrow">{settings.manifesto_eyebrow}</p>
        <h2 className="mt-2 max-w-2xl font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight" data-testid="manifesto-title">
          {settings.manifesto_title}
        </h2>
        <div className="mt-14 grid gap-6 lg:grid-cols-3 lg:gap-8">
          {cards.map((c, i) => (
            <motion.div
              key={c.title + i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`manifesto-chapter-${i + 1}`}
              className={`rounded-2xl border border-white/10 bg-[#12141A] p-8 transition-colors duration-500 ${ACCENTS[i % 3].border}`}
            >
              <div className={`font-mono text-5xl font-bold ${ACCENTS[i % 3].color} opacity-90`}>{String(i + 1).padStart(2, "0")}</div>
              <h3 className="mt-6 font-display text-lg sm:text-xl font-semibold">{c.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">{c.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
